import { AxiosRequestConfig } from 'axios';
import api from '../../../../api';
import { TokenAccessor } from '../../types/API';

export interface BasePayload {
  name: string;
  maxScore?: number;
  userMaxScore?: number;
}

interface SaveUserMaterialProps {
  axiosConfig: AxiosRequestConfig;
  moduleId: string;
  nodeId: string;
  payload: BasePayload;
}

async function saveUserMaterial({ moduleId, nodeId, axiosConfig, payload }: SaveUserMaterialProps) {
  const { data } = await api.post(
    `/studio/user/modules/${moduleId}/table-of-content/${nodeId}/user-material`,
    payload,
    axiosConfig,
  );

  return data;
}

interface UpdateUserMaterialProps {
  axiosConfig: AxiosRequestConfig;
  moduleId: string;
  nodeId: string;
  payload: BasePayload;
  materialId: string;
}

async function updateUserMaterial({ moduleId, nodeId, axiosConfig, payload, materialId }: UpdateUserMaterialProps) {
  const { data } = await api.patch(
    `/studio/user/modules/${moduleId}/table-of-content/${nodeId}/user-material/${materialId}`,
    payload,
    axiosConfig,
  );

  return data;
}

interface EditOrSaveUserMaterialProps {
  tokenAccessor: TokenAccessor;
  moduleId: string;
  nodeId: string;
  studioGroup: string;
  payload: BasePayload;
  materialId?: string;
}

export async function editOrSaveUserMaterial({ tokenAccessor, studioGroup, ...props }: EditOrSaveUserMaterialProps) {
  const token = await tokenAccessor.tokenGetter();

  const axiosConfig = {
    headers: {
      Authorization: `Bearer ${token}`,
      studioGroup,
    },
  };

  if (props.materialId) {
    return updateUserMaterial({ ...props, materialId: props.materialId, axiosConfig });
  }

  return saveUserMaterial({ ...props, axiosConfig });
}
